import React from "react";
import { Participant, Track } from "twilio-video";
import usePublications from "../../hooks/usePublications/usePublications";
import Publication from "../Publication/Publication";

interface IParticipantTracksProps {
  participant: Participant;
  videoOnly?: boolean;
  enableScreenShare?: boolean;
  videoPriority?: Track.Priority | null;
  isLocalParticipant?: boolean;
}

const ParticipantTracks: React.FC<IParticipantTracksProps> = ({
  participant,
  videoOnly,
  enableScreenShare,
  videoPriority,
  isLocalParticipant,
}) => {
  const publications = usePublications(participant);
  let filteredPublications;

  if (
    enableScreenShare &&
    publications.some((p) => p.trackName.includes("screen"))
  ) {
    filteredPublications = publications.filter(
      (p) => p.trackName.includes("screen") || p.kind !== "video"
    );
  } else {
    filteredPublications = publications.filter(
      (p) => !p.trackName.includes("screen")
    );
  }

  return (
    <>
      {filteredPublications.map((publication, index) => (
        <Publication
          key={index}
          publication={publication}
          participant={participant}
          isLocalParticipant={isLocalParticipant}
          videoOnly={videoOnly}
          videoPriority={videoPriority}
        />
      ))}
    </>
  );
};

export default ParticipantTracks;
